export const Blogs = [
    {
        id: 1,
        name: "BUild an website GUI that is railway booking system using ReactJS, GSAP and Styled-Components in MySQL Database",
        tags: ["react", "gsap", "styled-components", "mysql", "web-development"],
        // date: "13 May, 2021",
        imgSrc: "/railway.jpg",
        link: "https://github.com/anshul23102/Railway-Ticket-Booking-System.git",
    },
    {
        id: 2,
        name: "Sir Lewis: A Illustrator Work for a Own Project",
        tags: ["Adobe Illustrator", "illustrator", "graphic-design"],
        // date: "5 July, 2021",
        imgSrc: "/sir_lewis.png",
        // link: "https://codebucks.hashnode.dev/react-hamburger-menu",
    },
    {
        id: 10,
        name: "Design a Girl Character - A Illustrator Work for a Own Project",
        tags: ["Adobe XD", "xd", "graphic-design", "Adobe photoshop", ],
        // date: "26 May, 2021",
        imgSrc: "/ldr.png",
        // link: "https://www.canva.com/design/DAGV0Ut_d4A/xyhiBqYj5l-o3d_VfNXi6w/view?utm_content=DAGV0Ut_d4A&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h384192d438",
    },
    {
        id: 3,
        name: "Mid-Fi Prototype - Educational Service App Design",
        tags: ["Adobe XD", "xd", "graphic-design", "Figma"],
        // date: "6 July, 2021",
        imgSrc: "/m.png",
        link: "https://www.figma.com/design/7bwLPIuCrgllHStoDCzT4l/Mid-Fi-Prototype---Educational-Service?node-id=0-1&p=f&t=9bkyRIn3VxVUo4Ie-0",
    },

    {
        id: 4,
        name: "Sahayan App - 2023 UI/UX Design Project",
        tags: ["react", "figma", "xd", "graphic-design", "figma"],
        // date: "26 May, 2021",
        imgSrc: "/sahayan.png",
        link: "https://www.figma.com/proto/7cgVx8S86eg7oe09Cf9ywk/hci-group-10?node-id=168-756&starting-point-node-id=168%3A756",
    },
    {
        id: 5,
        name: "Angry Bird game - JavaFX",
        tags: ["JavaFDX", "LibGDX", "game-development"],
        // date: "3 Feb, 2021",
        imgSrc: "/image.png",
        link: "https://github.com/anshul23102/AngryBirdGUI_2.git",
    },
    {
        id: 6,
        name: "Course Registration System - Implement in Java",
        tags: ["Java", "JavaFX",],
        // date: "5 Jan, 2021",
        imgSrc: "/c.png",
        link: "https://github.com/anshul23102/Course_Registration_System",
    },
    {
        id: 7,
        name: "Byte Me - Food Ordering System Development in JAVA GUI",
        tags: ["Java", "JavaFX", "GUI", "food-ordering"],
        // date: "16 May, 2021",
        imgSrc: "/food.png",
        link: "https://github.com/anshul23102/ByteMEGUI_Food_Processing_System",
    },
    {
        id: 8,
        name: "Formulating Design Strategy - CiPD",
        tags: ["Adobe XD", "xd", "graphic-design", "Canva", "google scholar"],
        // date: "26 May, 2021",
        imgSrc: "/cpid.png",
        link: "https://www.canva.com/design/DAGUgofxDl8/CbI13fqyEpvlZdTeVdBOnQ/view?utm_content=DAGUgofxDl8&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h48813cfc8d",
    },
    {
        id: 9,
        name: "My Journal - A Personal Diary App",
        tags: ["Adobe XD", "xd", "graphic-design", "Canva", "though process"],
        // date: "26 May, 2021",
        imgSrc: "/asd.png",
        link: "https://www.canva.com/design/DAGV0Ut_d4A/xyhiBqYj5l-o3d_VfNXi6w/view?utm_content=DAGV0Ut_d4A&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h384192d438",
    },
    


];
